import { render, staticRenderFns } from "./singlePerson.vue?vue&type=template&id=50929185&scoped=true&"
import script from "./singlePerson.vue?vue&type=script&lang=js&"
export * from "./singlePerson.vue?vue&type=script&lang=js&"
import style0 from "./singlePerson.vue?vue&type=style&index=0&id=50929185&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50929185",
  null
  
)

export default component.exports